var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { WizardRouter } from './WizardRouter';
import { StepperProvider } from './StepperContext';
import { ActionsProvider } from './ActionsContext';
var Wizard = function (_a) {
    var initialSteps = _a.initialSteps, initialStep = _a.initialStep, children = _a.children;
    return (_jsx(StepperProvider, { children: _jsx(WizardRouter, __assign({ initialSteps: initialSteps, initialStep: initialStep }, { children: _jsx(ActionsProvider, { children: children }, void 0) }), void 0) }, void 0));
};
export default Wizard;
